import type { StateKey } from '@angular/core';
import { makeStateKey, TransferState } from '@angular/core';
import { MissingTranslationHandler, TranslateLoader, type TranslationObject } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';

import { WrikeMissingTranslationHandler } from 'src/services/translate-loader/translate-loader.factory';

function createTranslateLoaderFactory(projectName: string): (transferState: TransferState) => TranslateLoader {
    return function translateLoaderFactory(transferState: TransferState): TranslateLoader {
        return new TranslateWebpackDynamicImportLoader(projectName, transferState);
    };
}

class TranslateWebpackDynamicImportLoader implements TranslateLoader {
    constructor(
        private readonly projectName: string,
        private readonly transferState: TransferState
    ) {}

    public getTranslation(lang: string): Observable<TranslationObject> {
        const stateKey: StateKey<TranslationObject> = makeStateKey(`${this.projectName}_translations_${lang}`);
        const stateData = this.transferState.get(stateKey, null);

        if (stateData !== null) {
            return of(stateData);
        } else {
            return new Observable((observer) => {
                import(
                    /* webpackMode: "lazy", webpackChunkName: "i18n-[request]" */ `../../../assets/i18n/${lang}.json`
                )
                    .then((data) => {
                        const translations = data.default;

                        this.transferState.set(stateKey, translations);
                        observer.next(translations);
                        observer.complete();
                    })
                    .catch((error) => {
                        console.error('Unable to import translations:', error);
                    });
            });
        }
    }
}

export const translateModuleConfig = {
    loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoaderFactory('tp_fe'),
        deps: [TransferState],
    },
    missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: WrikeMissingTranslationHandler,
    },
    isolate: true,
};
